import { useExperiment } from '@/lib/experiments';
import { useAppAuth } from '@/lib/useAppAuth';
import { useFtueCompletion } from './ftueCompletion';

/** The `exp.ftue.experience` LaunchDarkly flag key. */
export const FTUE_EXPERIENCE_FLAG = 'exp.ftue.experience';

/** The variants that actually render a full-screen FTUE (control does not). */
export const FTUE_ARM_VARIANTS = ['make-a-call', 'step-by-step'] as const;

const ARM_SET = new Set<string>(FTUE_ARM_VARIANTS);

/**
 * True while the full-screen FTUE owns (or may be about to own) the screen —
 * derived from the same inputs as the gate itself, so consumers can suppress
 * work BEFORE the overlay mounts (a mount-signal would race the lobby's
 * first render). While the assignment is still resolving this errs on
 * "blocked": for control users that costs a sub-second delay on the
 * suppressed surfaces; for FTUE users it prevents the lobby firing
 * monetization calls/popups behind the overlay.
 */
export function useFtueBlocksLobby(): boolean {
  const { isOnboarded } = useAppAuth();
  const { completed } = useFtueCompletion();
  const { variant, ready } = useExperiment(FTUE_EXPERIENCE_FLAG);
  if (!isOnboarded || completed) return false;
  return !ready || ARM_SET.has(variant);
}
